package com.tovtalk.data.local

import kotlinx.browser.localStorage

actual fun clearAllAppDataForAccountDeletion() {
    try {
        localStorage.clear()
    } catch (e: Exception) {
        com.tovtalk.utils.logger.Logger.w("clearAllAppDataForAccountDeletion failed: ${e.message}", "AppDataClearer")
    }
}
